/* The Haaland Code — accessible cart drawer using the Cart AJAX API and the
   Section Rendering API for line-item markup (rendered by Liquid, not JS).
   Named hc-cart-drawer.js (not cart-drawer.js) to avoid overwriting Horizon's
   own stock cart-drawer.js, which other retained theme features still use. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function initCartDrawer() {
    const overlay = qs('[data-hc-cart-overlay]');
    const drawer = qs('[data-hc-cart-drawer]');
    if (!overlay || !drawer) return;

    let lastFocused = null;

    function setBusy(state) {
      drawer.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function updateCartCount(scopeEl) {
      const countSource = (scopeEl || document).querySelector('[data-hc-cart-item-count]');
      const badge = qs('[data-hc-cart-count]');
      if (!badge || !countSource) return;
      const count = countSource.getAttribute('data-hc-cart-item-count');
      badge.textContent = count;
      badge.hidden = Number(count) === 0;
    }

    function refresh() {
      setBusy(true);
      return fetch('/?sections=cart-drawer')
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          const html = data['cart-drawer'];
          if (!html) return;
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const newBody = wrapper.querySelector('[data-hc-cart-body]');
          const newFoot = wrapper.querySelector('[data-hc-cart-foot]');
          const body = qs('[data-hc-cart-body]', drawer);
          const foot = qs('[data-hc-cart-foot]', drawer);
          if (newBody && body) body.innerHTML = newBody.innerHTML;
          if (newFoot && foot) foot.innerHTML = newFoot.innerHTML;
          updateCartCount(wrapper);
          bindLineEvents();
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function open() {
      lastFocused = document.activeElement;
      overlay.setAttribute('data-open', 'true');
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      const closeBtn = qs('[data-hc-cart-close]', drawer);
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
      if (window.HC) window.HC.track('cart_view', {});
    }

    function close() {
      overlay.setAttribute('data-open', 'false');
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = drawer.querySelectorAll('button, a[href], input');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function changeLine(key, quantity, sourceEl) {
      setBusy(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then(function () {
        document.dispatchEvent(new CustomEvent('hc:cart:updated'));
        // The full cart page renders its own line items server-side (outside
        // the drawer markup this script refreshes), so reload it after a change.
        if (sourceEl && sourceEl.closest('.hc-cart-page')) {
          window.location.reload();
        }
      });
    }

    function bindLineEvents() {
      // Bound document-wide (not just inside the drawer) so the standalone
      // cart page's quantity/remove controls work too. Guarded against
      // double-binding since this runs again after every drawer refresh.
      document.querySelectorAll('[data-hc-cart-remove]').forEach(function (btn) {
        if (btn.dataset.hcBound) return;
        btn.dataset.hcBound = 'true';
        btn.addEventListener('click', function () {
          changeLine(btn.getAttribute('data-hc-cart-remove'), 0, btn);
        });
      });
      document.querySelectorAll('[data-hc-cart-qty]').forEach(function (input) {
        if (input.dataset.hcBound) return;
        input.dataset.hcBound = 'true';
        input.addEventListener('change', function () {
          const qty = Math.max(0, parseInt(input.value, 10) || 0);
          changeLine(input.getAttribute('data-hc-cart-qty'), qty, input);
        });
      });
    }

    overlay.addEventListener('click', close);
    document.querySelectorAll('[data-hc-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.querySelectorAll('[data-hc-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        refresh().then(open);
      });
    });

    document.addEventListener('hc:cart:updated', function () {
      refresh();
    });
    document.addEventListener('hc:cart:open', function () {
      refresh().then(open);
    });

    bindLineEvents();
    updateCartCount(document);
  }

  ready(initCartDrawer);
})();
